import Swiper, { Navigation, Pagination } from 'swiper'
Swiper.use([ Navigation, Pagination ])

class MainCities {
  
  constructor (el) {
    this.slider = null
    this.initElements( el )
    this.initDefault()
  }

  initElements ( el ) {
    this.el = el
    this.sliderContainer = el.querySelector('.js-main-cities-slider')
  }

  initDefault () {
    this.initSlider()
  }

  update () {
    const el = document.querySelector('.js-main-cities')
    this.initElements(el)
    this.initSlider()
  }

  destroy () {
    if ( this.slider ) {
      this.slider.destroy()
      this.slider = null
    }
  }

  initSlider () {
    this.slider = new Swiper( this.sliderContainer, {
      spaceBetween: 24,
      slidesPerView: 3,
      simulateTouch: false,
      observeParents: true,
      observer: true,
      breakpoints: {
        0: {
          spaceBetween: 16,
          slidesPerView: 1
        },
        768: {
          spaceBetween: 16,
          slidesPerView: 2
        },
        1024: {
          spaceBetween: 24,
          slidesPerView: 3
        }
      },
      navigation: {
        prevEl: '.js-slider-control-prev',
        nextEl: '.js-slider-control-next'
      },
      pagination: {
        el: '.js-slider-control-pagination',
        clickable: true
      }
    })
  }

}

document.addEventListener('DOMContentLoaded', e => {
  const el = document.querySelector('.js-main-cities')
  if ( el ) {
    window.MainCities = new MainCities(el)
  }
})